import { render, staticRenderFns } from "./NewLead.vue?vue&type=template&id=19ccaef4"
import script from "./NewLead.vue?vue&type=script&lang=ts"
export * from "./NewLead.vue?vue&type=script&lang=ts"
import style0 from "./NewLead.vue?vue&type=style&index=0&id=19ccaef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports